export default __webpack_public_path__ + "static/media/clustermanagement_openapi.5e782cbb.yaml";